import { createAsyncActionType } from '../async'

export const LOGIN = createAsyncActionType('LOGIN')
export const LOGOUT = 'LOGOUT'

export const logoutAction = {
  type: LOGOUT
}
